module.exports = __webpack_public_path__ + "img/Alarm-icon.440283c0.svg";